import * as React from "react";
import { StandardProps } from "@material-ui/core";
import { TypographyProps } from "@material-ui/core/Typography";
import MuiListItemText, { ListItemTextClassKey as MuiListItemTextClassKey } from "@material-ui/core/ListItemText";


export type ListItemTextClassKey = MuiListItemTextClassKey;


export interface ListItemTextProps
    extends StandardProps<React.HTMLAttributes<HTMLDivElement>, ListItemTextClassKey> {
    disableTypography?: boolean;
    inset?: boolean;
    primary?: React.ReactNode;
    primaryTypographyProps?: Partial<TypographyProps>;
    secondary?: React.ReactNode;
    secondaryTypographyProps?: Partial<TypographyProps>;
}



class ListItemText extends React.PureComponent<ListItemTextProps> {
    render() {
        const { ...props } = this.props;
        return <MuiListItemText {...props}>
            {this.props.children}
        </MuiListItemText>;
    }
}

export default ListItemText;